// modifer: styles/jss/nextjs-material-kit-pro/pages/blogPostSections/sectionBlogInfoStyle
import { section, container, grayColor, cardTitle } from 'styles/jss/original/base';
const styles = {
  section,
  container,
  card: {
    marginTop: '0',
    textAlign: 'left',
    '@media (max-width: 640px)': {
      marginBottom: '10px'
    }
  },
  cardTitle: {
    ...cardTitle,
    '@media (max-width: 640px)': {
      marginTop: '10px !important'
    }
  },
  description: {
    fontSize: '0.875rem',
    color: grayColor[0]
  }
};

export default styles;
